module.exports = __webpack_public_path__ + "img/BoatBonanzaDownUnder.517014ef.png";